<template>
  <div class="organization-overview  pa-10" v-if="organization">

    <div class="d-flex justify-end">
      <audit-trail-button entity-type="Organization" :entity-id="$route.params.id" />
    </div>



    <headline>
      {{ $t('informations') }}
    </headline>

    <div class="grid">
      <v-row>
        <v-col class="label" sm="3">
          {{ $t('name') }} :
        </v-col>
        <v-col sm="3">
          {{ organization.name ? organization.name : '-' }}
          <v-btn class="ml-5" small :to="{name: 'organizations.edit'}">
            <v-icon left>mdi-cog</v-icon>
            {{ $t('edit')}}
          </v-btn>
        </v-col>
        <v-col class="label" sm="3">
          {{ $t('account-number') }} :
        </v-col>
        <v-col sm="3">
          {{ organization.accountNumber}}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="label" sm="3">
          {{ $tc('organization.perimeter.perimeter') }} :
        </v-col>
        <v-col sm="3">
          {{ organization.perimeter?.name ? localizedString(organization.perimeter?.name) : '-' }}
        </v-col>
        <v-col class="label" sm="3">
          {{ $tc('organization.sub-perimeter.sub-perimeter') }} :
        </v-col>
        <v-col sm="3">
          {{ organization.subPerimeter?.name ? localizedString(organization.subPerimeter?.name) : '-' }}
        </v-col>
      </v-row>



      <v-row  v-if="organization.parentId && allowedOrganizationIds.includes(organization.parentId)">
        <v-col class="label" sm="3">
          {{ $t('organization.parent-organization') }} :
        </v-col>
        <v-col sm="9">
          <v-btn small :to="{name: 'organizations.detail', params: {id: organization.parentId }}">
            <v-icon left>mdi-arrow-right</v-icon>
            {{ cleanedPath(organization.path.replace('/' + organization.name , '')) }}
          </v-btn>
        </v-col>

      </v-row>




      <v-row>
        <v-col class="label" sm="3">
          {{ $t('organization.registration-number') }} :
        </v-col>
        <v-col sm="3">
          {{ organization.registrationNumber ? organization.registrationNumber : '-'}}
        </v-col>
        <template v-if="false">
          <v-col class="label" sm="3">
            {{ $t('billing-mode.label') }} :
          </v-col>
          <v-col sm="3">
            {{ organization.billingMode ? $t('billing-mode.' + organization.billingMode) : '-' }}
          </v-col>
        </template>
      </v-row>

      <v-row>
        <v-col class="label" sm="3">
          {{ $t('created-at') }} :
        </v-col>
        <v-col sm="3">
          {{ organization.createdAt | formatDate }}
        </v-col>
      </v-row>


    </div>


    <div class="mt-16">
      <headline>
        {{ $tc('organization.sub-organization', 2) }}
      </headline>
      <v-row>
        <v-col class="text-right">
          <v-btn small :to="{name: 'organizations.add', query: {'oid': this.organization.id}}">
            <v-icon left>mdi-plus</v-icon>
            {{ $t('organization.add-organization')}}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <search-field
              :placeholder="$t('organization.search-organization')"
              :search.sync="search"
              :options.sync="options"
              clearable
          >
          </search-field>
        </v-col>
      </v-row>


      <v-row no-gutters class="mt-10">
        <v-col>
          <v-data-table
              class="organization-list"
              :headers="[
                {text: this.$t('name'), value: 'name', align: 'left'},
                {text: this.$t('account-number'), value: 'accountNumber', width: 150},
                {text: this.$tc('operator.operator'), value: 'cpoOperator.id', width: 100},
              ]"
              :items="items"
              :loading="loading"
              :options.sync="options"
              :server-items-length="total"
              @click:row="row => $router.push({name: 'organizations.detail', params: {id: row.id}})"
          >
            <template #item.name="{item}">
              <router-link :to="{name: 'organizations.detail', params: {id: item.id}}">
                <v-icon left>{{ commonIcons().organization.type[item.type] }}</v-icon>
                <span style="font-weight: 300;">{{ item.path.substr(0, item.path.length - item.name.length) }}</span><span class="red--text">{{ item.name }}</span>
              </router-link>
            </template>

          </v-data-table>

        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import AuditTrailButton from "@elements/AuditTrailButton.vue";

import OrganizationRepository from "@repository/OrganizationRepository";

export default {
  components: {AuditTrailButton},

  data() {
    return {
      search: '',
      selectedItem: null,
      items: [],
      loading: false,
      options: null,
      total: 0,
    }
  },

  watch: {
    search() {
      this.loadChildren()
    },

    options() {
      this.loadChildren()
    },

    'organization.id'() {
      this.loadChildren()
    },
  },

  computed: {
    organization() {
      return this.$parent.organization ?? null
    },

    allowedOrganizationIds() {
      const allowedId = []
      let founded = false;
      if(this.organization) {
        for(let i = 0; i < this.organization.hierarchies.length; i++) {
          if(founded || this.currentUser.organizations.includes(this.organization.hierarchies[i])) {
            allowedId.push(this.organization.hierarchies[i])
            founded = true
          }
        }
      }
      return allowedId
    },

  },

  methods: {

    cleanedPath(path) {
      let newPath = ''
      let pathPart = path.split('/')
      if(this.organization) {
        for(let i = 0; i < this.organization.hierarchies.length && i < pathPart.length; i++) {
          if(this.allowedOrganizationIds.includes(this.organization.hierarchies[i])) {
            if(newPath) {
              newPath += '/'
            }
            newPath += pathPart[i]
            if(this.organization.hierarchies[i] === this.organization.id) {
              break;
            }
          }
        }
      }
      return newPath
    },

    loadChildren() {
      this.loading = true

      let data = {
        searchText: this.search,
      }

      if(this.organization?.id) {
        data.parentId = this.organization?.id
      }

      if (this.options.itemsPerPage > -1) {
        data.offset = (this.options.page * this.options.itemsPerPage) - this.options.itemsPerPage
      }
      data.limit = this.options.itemsPerPage


      if (this.options.sortBy.length > 0) {
        data.orderBy = this.options.sortBy[0]
      }

      if (this.options.sortDesc.length > 0) {
        data.orderDirection = this.options.sortDesc[0] ? 'desc' : 'asc'
      }

      // Abort bucket UNIQUE to this component instance (`_uid`) — see OrganizationChildren. Keeps this sub-orgs
      // listing off the shared 'default' bucket so an unrelated org search (or the sibling instance while
      // navigating parent↔child) can no longer cancel it and leave the spinner stuck. Synchronously available,
      // unlike the org id which loads async.
      OrganizationRepository.search(data, `org-info-children-${this._uid}`).then(results => {
        this.total = results.total
        this.items = results.items
        this.loading = false
      }).catch(e => {
        // Superseded by our own newer search → that request now owns the spinner; don't touch loading or toast.
        if (e.code === 'ERR_CANCELED' || e.name === 'CanceledError' || e.name === 'AbortError') return
        this.notifyError(e)
        this.loading = false
      })
    },

  }
}
</script>

<style lang="scss">


.organization-overview {

}

</style>
